import { render, staticRenderFns } from "./StudyBox.vue?vue&type=template&id=374aeeb8&"
import script from "./StudyBox.vue?vue&type=script&lang=js&"
export * from "./StudyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports